import React, { Component } from 'react'
import './Project.css'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { Transition } from 'react-spring'

class Details extends React.Component {
  render () {
    const links = this.props.links
    const linkElements = []
    linkElements.push(<p key={this.props.name + 'description'} className='sec-text'>{this.props.description}</p>)
    for (let i = 0; i < links.length; i++) {
      linkElements.push(
        <a key={this.props.name + 'link' + i} rel='noopener noreferrer' target='_blank' href={links[i][0]} className='project-icon'>
          <FontAwesomeIcon icon={links[i][1]} size='lg' />
        </a>)
    }

    const ELEMENTS = styles => <div style={styles}>{linkElements}</div>
    return (
      <div>
        <Transition
          items={this.props.show}
          from={{ overflow: 'hidden', opacity: 0 }}
          enter={{ opacity: 1 }}
          leave={{ opacity: 0, height: 0 }}
          config={{ duration: 250 }}
        >
          {show => show && ELEMENTS}
        </Transition>
      </div>
    )
  }
}

class Project extends Component {
  constructor (props) {
    super(props)
    this.state = { isHidden: true }
  }

    toggleHidden = () => this.setState((prevState) => ({ isHidden: !prevState.isHidden }));

    render () {
      return (
        <div className='project'>
          <button type='button' onClick={() => this.toggleHidden()} className='project-name'>{this.props.name}</button>
          {
            <Details description={this.props.description} links={this.props.links} show={!this.state.isHidden} />

          }
        </div>
      )
    }
}

export default Project
